import { render, staticRenderFns } from "./FavouriteIndicator.vue?vue&type=template&id=76887526&"
import script from "./FavouriteIndicator.vue?vue&type=script&lang=js&"
export * from "./FavouriteIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports